import { render, staticRenderFns } from "./Mining.vue?vue&type=template&id=8bf788c8"
import script from "./Mining.vue?vue&type=script&lang=js"
export * from "./Mining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports